import { Link, graphql } from 'gatsby';
import { MDBCard, MDBCardBody, MDBCol, MDBContainer, MDBRow } from 'mdbreact';

import Layout from '../components/layout';
import React from 'react';
import SEO from '../components/seo';
import SitemapMenu from '../components/menus/sitemapmenus';
import styled from 'styled-components';

let gmdv = require(`../ghc_config`);

const MDBCardCompMenu = styled(MDBCard)`
    width:100%;
    margin: 0px;
    padding:0px;
    position: relative;
    left: 50%;
    top: 14px!important;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 1;

`

const MDBCardBodyComp = styled(MDBCardBody)`
    text-align: left;
    h5{
        margin-bottom: 0rem;
    }
    ul{
        width:100%;
        margin: 0px;
        padding: 0px;
        list-style-position: outside;
        list-style: none;
        li {
            width:100%;
            background: none;
            #border-bottom: 1px #ccc solid;
            padding: 0em 0.1em;
            margin: 0 auto;
            display: inline-block;
            a{
                color: #575549;
                font-size: 0.8em;
            }
            li {
                padding: 0em 0.4em;
                border-bottom: none;
            }
        }
    }
`

const Detail = ({ data }) => {

    let MainMenu = data.allMenuLinkContentMenuLinkContent.edges

    return (
        <Layout>
        <SEO title={`Genesis HealthCare > Sitemap`} />
            <main>
                <MDBContainer tag="section" id="maincontent">
                    <MDBCardCompMenu>
                        <MDBCardBodyComp className="d-md-inline">
                            <h3 className="pagetitle" >Site Map</h3>
                        </MDBCardBodyComp>
                    </MDBCardCompMenu>
                    <MDBRow>
                        {MainMenu.map((item, key) => {
                            //  Menu relation
                            let menuName = gmdv.getMenuid(item.node.link.uri)
                            return(
                            <MDBCol md="6">
                                <MDBCardCompMenu>
                                    <MDBCardBodyComp className="d-md-inline">
                                        <div key={key}>
                                            <Link  to={item.node.link.uri.toLowerCase().replace('internal:', '')} >
                                                <h5>{item.node.title}</h5>                                        
                                            </Link>
                                            <SitemapMenu menuName={menuName}/> 
                                            </div>
                                    </MDBCardBodyComp>
                                </MDBCardCompMenu>
                            </MDBCol>
                            )
                        })}
                        <MDBCol md="6">
                            <MDBCardCompMenu>
                                <MDBCardBodyComp className="d-md-inline"> 
                                    <div>
                                        <Link to={`/about-us`} >
                                            <h5>About Us</h5>                                        
                                        </Link>
                                        <SitemapMenu menuName={`about-us`}/> 
                                    </div>
                                </MDBCardBodyComp>
                            </MDBCardCompMenu>
                        </MDBCol>
                        <MDBCol md="6">
                            <MDBCardCompMenu>
                                <MDBCardBodyComp className="d-md-inline"> 
                                    <div>
                                        <a href={`https://www.genesiscareers.jobs/`} >
                                            <h5>Career Opportunities</h5>
                                        </a>
                                    </div>
                                </MDBCardBodyComp>
                            </MDBCardCompMenu>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </main>
        </Layout>
    )
}

export default Detail;

export const query = graphql`
query sitemap {
    #Mainmenu
    allMenuLinkContentMenuLinkContent(sort: {fields: [weight], order: ASC}, filter: {menu_name: {eq: "main"}}) {
        edges {
            node {
                drupal_id
                title
                link {
                    uri
                    title
                }
                drupal_parent_menu_item
                menu_name
            }
        }
        totalCount
    }   
}
`